// @ts-nocheck

import React from 'react';
import styled from 'styled-components';

import { __ } from '../../i18n/l10n';
import theme from '../../styled-components/dark';
import { columnGap } from '../../styled-components/dark/helpers';
import BasketCombinationsHeader from '../BasketCombinationsHeader';
import BasketCombinationsSelectorLine from '../BasketCombinationsSelectorLine';
import { type BasketCombinationsSelectorLineDataType } from '../BasketCombinationsSelectorLine';
import RoundedButton from '../RoundedButton';

const Wrapper = styled.div``;

const StyledBasketCombinationsHeader = styled(BasketCombinationsHeader)`
  margin-bottom: 1em;
`;

const Combinations = styled.div``;

const StyledCombinationsSelectorLine = styled(BasketCombinationsSelectorLine)`
  position: relative;

  &:not(:last-child) {
    margin-bottom: 1.6em;

    &:after {
      content: '';
      position: absolute;
      bottom: -50%;
      height: 1px;
      width: 100%;
      background: ${theme.BasketCombinationsSelectorLine.separatorBackgroundColor};
      transform: translateY(100%);
    }
  }
`;

const colGap = columnGap(0.5);
const CombinationsFooter = styled.div`
  margin-top: 1em;

  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: center;

  ${colGap}
`;

const ResetButton = styled(RoundedButton)``;

const SubmitButton = styled(RoundedButton)``;

type BasketCombinationsSelectorProps = {
  combinations: Array<BasketCombinationsSelectorLineDataType>;
  onToggleSelection: () => void;
  onReset: (() => void) | null;
  onSubmit: (() => void) | null;
  className?: string;
  nbBets: number;
};

const BasketCombinationsSelector = ({
  combinations,
  onToggleSelection = () => {},
  onReset,
  onSubmit,
  className,
  nbBets,
}: BasketCombinationsSelectorProps) => {
  return (
    <Wrapper className={className}>
      <StyledBasketCombinationsHeader label={__('Combinations')} counter={nbBets} />
      <Combinations>
        {combinations.map(({ id, label, counter, selected }, index) => (
          <StyledCombinationsSelectorLine
            key={`comb-select-${index}`}
            id={id}
            label={label}
            counter={counter}
            selected={selected}
            onToggleSelection={onToggleSelection}
          />
        ))}
      </Combinations>

      {onReset || onSubmit ? (
        <CombinationsFooter>
          {onReset ? (
            <ResetButton
              backgroundColor={theme.BasketCombinationsSelector.resetButtonBackgroundColor}
              color={theme.BasketCombinationsSelector.resetButtonColor}
              borderColor={theme.BasketCombinationsSelector.resetButtonBorderColor}
              label={__('Reset')}
              onClick={onReset}
            />
          ) : null}
          {onSubmit ? (
            <SubmitButton
              backgroundColor={theme.BasketCombinationsSelector.submitButtonBackgroundColor}
              color={theme.BasketCombinationsSelector.submitButtonColor}
              borderColor={theme.BasketCombinationsSelector.submitButtonBorderColor}
              label={__('Confirm')}
              onClick={onSubmit}
            />
          ) : null}
        </CombinationsFooter>
      ) : null}
    </Wrapper>
  );
};

export default BasketCombinationsSelector;
